<template>
  <layout-basic>
    <v-container v-if="loading" fluid>
      <v-row>
        <v-col md="12">
          <v-skeleton-loader type="article"></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else fluid class="text-left">
      <v-row>
        <v-col md="6">
          <v-row>
            <v-col>
              <h1>{{ course.name }}</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" offset-md="3">
              <v-img :src="imgSrc" />
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6">
          <v-row>
            <v-col>
              <h4 class="py-1">Duration</h4>
              <p>{{ duration }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h4 class="py-1">Description</h4>
              <div class="course-description" @click="handleLinkClick" v-html="course.description"></div>
            </v-col>
          </v-row>
          <v-row v-if="hasTopics">
            <v-col>
              <h4 class="py-1">Tags</h4>
              <v-chip v-for="item in course.topics.data" :key="item.id" class="mr-1 mb-1">{{ item.tag }}</v-chip>
            </v-col>
          </v-row>
          <v-row v-if="hasVideos">
            <v-col>
              <h4 class="py-1">Training Materials</h4>
              <v-list two-line>
                <v-list-item-group>
                  <template v-for="(item, index) in course.videos.data">
                    <v-list-item :key="item.id" two-line>
                      <template>
                        <v-list-item-icon class="list-icon">
                          <v-icon>fa-video</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="ml-5">
                          <v-list-item-title>{{item.title}}</v-list-item-title>
                          <v-list-item-subtitle class="text--primary">{{ item.description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-divider v-if="index + 1 < course.videos.length" :key="index"></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
          <v-row v-if="hasDocuments">
            <v-col>
              <h4 class="py-1">Additional Content</h4>
              <v-list two-line>
                <v-list-item-group>
                  <template v-for="(item, index) in course.documents.data">
                    <v-list-item :key="item.id" two-line>
                      <template>
                        <v-list-item-icon class="list-icon">
                          <v-icon>fa-file-alt</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="ml-5">
                          <v-list-item-title>{{item.title}}</v-list-item-title>
                          <v-list-item-subtitle class="text--primary">{{ item.description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-divider v-if="index + 1 < course.documents.length" :key="index"></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import courseAPI from "@/api/course.js";
import { IMPROVE_CONFIG } from "@/config.js";
import thumbSizes from "@/utils/thumbs.js";

export default {
  name: "CourseDetails",
  components: {
    LayoutBasic,
  },
  data() {
    return {
      course: [],
      courseMaterials: [],
      loading: false,
      videoId: null,
      videos: [],
      readOnly: true,
      id: this.$route.params.id,
      params: "?include=thumbnail,topics,videos,documents"
    };
  },
  computed: {
    duration: function() {
      if (this.course.hours != 0) {
        return this.course.hours + " hr " + this.course.minutes + " mins";
      } else {
        return this.course.minutes + " minutes";
      }
    },
    hasTopics: function() {
      if (
        this.course.topics != null &&
        this.course.topics.hasOwnProperty("data") &&
        this.course.topics.data.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasVideos: function() {
      if (
        this.course.videos != null &&
        this.course.videos.hasOwnProperty("data") &&
        this.course.videos.data.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasDocuments: function() {
      if (
        this.course.documents != null &&
        this.course.documents.hasOwnProperty("data") &&
        this.course.documents.data.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    imgSrc: function() {
      if (this.course.thumbnail != null) {
        if (this.course.thumbnail.hasOwnProperty("data")) {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: this.course.thumbnail.data.key,
            edits: thumbSizes.medium
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        } else {
          const imageRequest = JSON.stringify({
            bucket: `${IMPROVE_CONFIG.BUCKET}`,
            key: this.course.thumbnail.key,
            edits: thumbSizes.medium
          });
          const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
            imageRequest
          )}`;
          return url;
        }
      } else {
        return 'https://placehold.co/350/000/fff?text='+this.course.name;
      }
    }
  },
  mounted() {
    this.getCourse();
    //this.getCourseMaterials();
  },
  methods: {
    getCourse() {
      this.loading = true;
      courseAPI.getCourse(this.id, this.params).then(response => {
        this.loading = false;
        this.course = response.data.data;
      });
    },
    handleLinkClick(event) {
      // Check if the clicked element is a link
      if (event.target.tagName === 'A' || event.target.parentElement.tagName === 'A') {
        // Prevent the default action of the click event
        event.preventDefault();
        // Get the link URL
        const linkUrl = event.target.tagName === 'A' ? event.target.href : event.target.parentElement.href;
        // Open the link URL in a new tab
        window.open(linkUrl, '_blank');
      }
    }
  }
};
</script>
<style>
.list-icon {
  margin: auto !important;
  vertical-align: middle;
}
</style>
